export default __webpack_public_path__ + "img/b82cc614e94139fea44673d0d28d9257.png";